import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginRest } from '../../login/login.rest';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';

@Component({
  selector: 'app-object-states',
  templateUrl: './object-states.component.html',
  styleUrls: ['./object-states.component.scss']
})
export class ObjectStatesComponent implements OnInit, AfterViewInit {
  @ViewChild(GridComponent) grid: GridComponent;
  private path : string;
  private currentUser: any; 
  public viewEnable = true;

  private headers = [
    { displayName: 'Nazwa obiektu', propertyName: 'objectName', propertyType: 'string' },
    { displayName: 'Status obiektu', propertyName: 'name', propertyType: 'string' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private loginRest: LoginRest,
    private spinnerService: SpinnerService
  ) { }

    ngOnInit() {
      this.spinnerService.show();
      this.path = 'api/objectstates/grid'; 
    }

    ngAfterViewInit() {
      this.spinnerService.hide();
    }
}
